export default {"src":"/_next/static/media/coffee-mugg.cbdf3f13.svg","height":16,"width":16};